import React, {Component} from 'react';
import NavbarComponent from "../components/NavbarComponent";
import MatrixTable from "../components/tables/MatrixTable";
import {Alert, Grow, Snackbar} from "@mui/material";
import UserData from "../backend/dataservices/UserSettings";
import TransformedMatrixTable from "../components/tables/TransformedMatrixTable";

class MatrixPage extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            transformed: false,                         //courseMatrix = true | employeesMatrix = false
            snackbarOpen: false,
            snackbarText: '',
            snackbarSeverity: 'success',
        };
    }

    componentDidMount() {
        UserData.fetchMatrixUserSettings().then(settings => {
           this.initTransformed(settings.type);
        });
    }


    initTransformed(type) {
        this.setState({
            transformed: type === 'courseMatrix'
        });
    }

    transformLayout = () => {
        this.setState({
            transformed: !this.state.transformed,
        });
    }

    saveLayout(courses) {
        let matrixType = this.state.transformed ? 'courseMatrix' : 'employeeMatrix';
        UserData.saveMatrixSettings(matrixType, courses).then(value => {
            this.setState({
                snackbarOpen: true,
                snackbarText: 'Layout gespeichert',
                snackbarSeverity: 'success'
            });
        }, (error) => {
            this.setState({
                snackbarOpen: true,
                snackbarText: 'Ein unerwarteter Fehler ist aufgetreten',
                snackbarSeverity: 'error'
            });
        });
    }

    closeSnackbar = () => {
        this.setState({
            snackbarOpen: false
        })
    }

    render() {
        return (
            <div>
                <NavbarComponent initValue={"/matrix"}/>
                {this.state.transformed ?
                    <TransformedMatrixTable transformLayout={this.transformLayout} saveLayout={(courses) => {
                        this.saveLayout(courses);
                    }}/>
                    :
                    <MatrixTable transformLayout={this.transformLayout} saveLayout={(courses) => {
                        this.saveLayout(courses);
                    }}/>
                }
                <Snackbar open={this.state.snackbarOpen} autoHideDuration={5000} onClose={this.closeSnackbar}
                          anchorOrigin={{vertical: "top", horizontal: "right"}} TransitionComponent={Grow}>
                    <Alert onClose={this.closeSnackbar} severity={this.state.snackbarSeverity} sx={{width: '100%'}}>
                        {this.state.snackbarText}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
}

export default MatrixPage;